/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import axios, { AxiosInstance } from 'axios';

import { VApplication } from '../application/index';
import { DeviceInfoService } from './device-info.service';
import { NO_IMAGE } from "../assets/images";

const SERVICE_NAME = 'product-provenance-rest.service';
const { LoggerModule } = require("@vlinder-web/logger-module-react");
const log: any = LoggerModule.getInstance();

const is = require('is_js');

interface IProps {
    baseURL: string;
    timeout?: number;
    headers?: any;
}

const getDeviceInfoService = () => {
    const app = VApplication.getInstance();
    return app?.getSync('services.DeviceInfoService') as DeviceInfoService;
};

export class ProductProvenanceRestService {
    name = SERVICE_NAME;
    private static instance: ProductProvenanceRestService;

    private api: AxiosInstance;

    private constructor(props: IProps | any) {
        const deviceInfoService = getDeviceInfoService();
        this.api = axios.create({
             baseURL: props.baseURL,
            timeout: props.timeout ?? 30000, // 30 secs
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                ...{ ...deviceInfoService.getDeviceInfo() },
                ...{ ...deviceInfoService.getAppInfo() },
                ...{ ...(props.headers || {}) },
            },
        });
        this.report();
    }

    static getInstance(props: IProps | any = {}) {
        if (!this.instance) {
            this.instance = new ProductProvenanceRestService(props);
        }
        return this.instance;
    }
    async init() {}

    _getTimeline = (data: any) => {
        let _timeline: any[] = [];
        data &&
            Array.isArray(data) &&
            data.length > 0 &&
            data.map((item: any, index: number) => {
                item?.data &&
                    Array.isArray(item?.data) &&
                    item?.data.length > 0 &&
                    item?.data.map((ele: any, eleIndex: number) => {
                        _timeline.push({
                            id: ele?.credTxId,
                            key: ele?.gtinKey,
                            label: ele?.title,
                            subtitle: ele?.subtitle,
                        });
                    });
            });
        return _timeline;
    };

    _provenanceData = (data: any) => {
        let _provenance: any = {};
        let _data = data && Array.isArray(data) && data.length > 0 && data[0];
        _data =
            _data?.data &&
            Array.isArray(_data?.data) &&
            _data?.data.length > 0 &&
            _data?.data[0];

        return {
            idx: _data?.credTxId,
            title: _data?.title,
            subtitle: _data?.subtitle,
            // serialNo: 'Rare #/1',
            // img: "https://dev-dc.vlinder.io/imgsrv/ipfs/QmTJFM4QPeN5aYc7uDZrHNdsA8oXQrn58fspRNNV3PmSYp",
            // // tag: 'DIAMOND',
            // // productCategory: 'collectibles',
            // // category: 'diamond',
            // price: [
            //     {
            //         type: "fiat",
            //         currency: "USD",
            //         locale: "en-US",
            //         amount: 1500.0,
            //     },
            //     {
            //         type: "crypto",
            //         currency: "ETH",
            //         amount: 0.5,
            //     },
            // ],
            // createdBy: {
            //     userName: "SWISS TIMING",
            //     userId: "swiss-timing",
            //     link: "/swiss-timing",
            //     authProofUrl:
            //         "https://gateway.pinata.cloud/ipfs/QmTJFM4QPeN5aYc7uDZrHNdsA8oXQrn58fspRNNV3PmSYp",
            // },
            // meta: [
            //     {
            //         key: "Item",
            //         value: "Track & field starting block with loudspeaker",
            //     },
            //     {
            //         key: "Dimensions (LxWxH) ",
            //         value: "990 x 410 x 220 to 260 mm (depend to the position of the footrest)",
            //     },
            //     {
            //         key: "Weight",
            //         value: "13 KG",
            //     },
            //     {
            //         key: "Acoustic signals",
            //         value: "False start: 104 dB @ 1m, Gun shot: 114 dB @ 1m, 1x Tuchel 7pMT (for thrust sensors and loudspeaker)",
            //     },
            //     {
            //         key: "Operating temperature ",
            //         value: "0 to +50°C ",
            //     },
            //     {
            //         key: "Storage temperature  ",
            //         value: "-10°C to +60°C  ",
            //     },
            //     {
            //         key: "Protection",
            //         value: "IP44",
            //     },
            //     {
            //         key: "Certifications",
            //         value: "CE and RoHS compliant IAAF Certified Product",
            //     },
            // ],
            // // actions: [
            // //     {
            // //         key: "buyNowFiat",
            // //         title: "Buy in USD"
            // //     },
            // //     {
            // //         key: "buyNowCrypto",
            // //         title: " Buy in ETH"
            // //     }
            // // ],
            // images: [
            //     {
            //         original: NO_IMAGE,
            //         thumbnail: NO_IMAGE,
            //         thumbnailHeight: "70",
            //         thumbnailClass: "image-thumb",
            //     },
            // ],
        };
    };

    async productview(payload: string) {
        log.info(`in productView service.`, payload);
        try {
            const res = await this.api.post(
                "/provenance/full_provenance/no_auth/",
                {
                    barcode: payload,
                }
            );
            if (res) {
                let _data = res?.data?.data;
                if (_data)
                   
                    return {
                        title: _data?.product?.title,
                        subTitle: "Provenance Journey",
                        timeline: this._getTimeline(_data?.provenance?.data),
                        smtimeline: _data?.provenance?.data,
                        provenanceData: this._provenanceData(
                            _data?.provenance?.data
                        ),
                    };
            }
        } catch (err) {}
    }

    _provenanceStepData = (data: any) => {
        let _provenance: any = {};

        const _getMeta = (metaData: any) => {
            let _meta : any[] = [];
            metaData && Array.isArray(metaData) && metaData.length > 0 && metaData.map((item: any, index: number) => {
                _meta.push({
                    key: item?.label,
                    value: item?.value
                })
            });
            return _meta;

        }

        return {
            //idx: _data?.credTxId,
            title: data?.ProvDetailInfo?.title,
            subtitle: data?.ProvStepTitle?.title,
            //serialNo: 'Rare #/1',
            // img: "https://dev-dc.vlinder.io/imgsrv/ipfs/QmTJFM4QPeN5aYc7uDZrHNdsA8oXQrn58fspRNNV3PmSYp",
            // // tag: 'DIAMOND',
            // // productCategory: 'collectibles',
            // // category: 'diamond',
            // price: [
            //     {
            //         type: "fiat",
            //         currency: "USD",
            //         locale: "en-US",
            //         amount: 1500.0,
            //     },
            //     {
            //         type: "crypto",
            //         currency: "ETH",
            //         amount: 0.5,
            //     },
            // ],
            // createdBy: {
            //     userName: "SWISS TIMING",
            //     userId: "swiss-timing",
            //     link: "/swiss-timing",
            //     authProofUrl:
            //         "https://gateway.pinata.cloud/ipfs/QmTJFM4QPeN5aYc7uDZrHNdsA8oXQrn58fspRNNV3PmSYp",
            // },
            meta: _getMeta(data?.ProvDetailInfo?.provInfoList),
            // // actions: [
            // //     {
            // //         key: "buyNowFiat",
            // //         title: "Buy in USD"
            // //     },
            // //     {
            // //         key: "buyNowCrypto",
            // //         title: " Buy in ETH"
            // //     }
            // // ],
            images: [
                {
                    original: NO_IMAGE,
                    thumbnail: NO_IMAGE,
                    thumbnailHeight: "70",
                    thumbnailClass: "image-thumb",
                },
            ],
        };
    }

    async provenanceStepDetailView(payload: any) {
        log.blue(SERVICE_NAME, ":", payload);
        try {
            const res = await this.api.post(
                "/provenance/step_cred/no_auth/",
                {
                    gtin: payload?.gtinKey,
                    credTxId: payload?.credTxId
                }
            );
            if (res) {
               
                let _data = res?.data?.data;
                if (_data) {
                    return {
                        provenanceData: this._provenanceStepData(
                            _data
                        ),
                        CHIP_LIST: _data?.ChipList,
                        PROV_DETAIL_INFO: _data?.ProvDetailInfo,
                        PROV_STEP_TITLE: _data?.ProvStepTitle,
                        PROV_STEP_TITLE_CARD: _data?.ProvStepTitleCard,
                        PROV_STEP_GEOJSON: _data?.provMapProps,
                    };
                }
                // return {

                // }
            }
            // let _data =  {CHIP_LIST,PROV_DETAIL_INFO,PROV_STEP_TITLE,PROV_STEP_TITLE_CARD }
            // return _data;
        } catch (err) {}
    }

    private report() {
        log?.info(SERVICE_NAME, `⚡⚡⚡===================⚡⚡⚡`);
        log?.info(SERVICE_NAME, 'Module Report');
        log?.info(SERVICE_NAME, '⦿ Name: ' + this.name);
        log?.info(SERVICE_NAME, `⚡⚡⚡===================⚡⚡⚡`);
    }
}
